interface RotativoInputData {
  readonly valorFatura: string;
  readonly valorPago: string;
  readonly taxaJuros: string;
  readonly diasAtraso: string;
  readonly multaAtraso: string;
  readonly jurosMora: string;
  readonly numeroMeses: string;
}

interface RotativoCalculoMes {
  readonly mes: number;
  readonly saldoInicial: number;
  readonly jurosRotativo: number;
  readonly iofMensal: number;
  readonly iofDiario: number;
  readonly multa: number;
  readonly jurosMora: number;
  readonly totalMes: number;
  readonly saldoFinal: number;
  readonly percentualAumento: number;
  readonly atingiuLimite: boolean;
}

interface RotativoBreakdown {
  readonly valorOriginal: number;
  readonly valorPago: number;
  readonly saldoRotativo: number;
  readonly taxaJurosMensal: number;
  readonly diasAtraso: number;
  readonly calculoDetalhado: {
    readonly jurosRotativo: number;
    readonly iofMensal: number;
    readonly iofDiario: number;
    readonly multa: number;
    readonly jurosMora: number;
  };
  readonly limiteReglamentario: number;
  readonly percentualLimite: number;
}

interface RotativoComparacao {
  readonly cenarioMinimo: {
    readonly descricao: string;
    readonly totalPagar: number;
    readonly totalJuros: number;
    readonly tempo: number;
  };
  readonly cenarioParcelamento: {
    readonly descricao: string;
    readonly totalPagar: number;
    readonly totalJuros: number;
    readonly tempo: number;
  };
  readonly cenarioQuitacao: {
    readonly descricao: string;
    readonly totalPagar: number;
    readonly totalJuros: number;
    readonly tempo: number;
  };
}

interface RotativoAlerta {
  readonly tipo: 'info' | 'warning' | 'danger';
  readonly titulo: string;
  readonly mensagem: string;
  readonly icone: string;
}

type RotativoResultsType = {
  readonly breakdown: RotativoBreakdown;
  readonly calculoMeses: RotativoCalculoMes[];
  readonly comparacao: RotativoComparacao;
  readonly alertas: RotativoAlerta[];
  readonly totalJurosAcumulados: number;
  readonly valorFinalProjetado: number;
  readonly economiaQuitacao: number;
  readonly tempoQuitacao: number;
};

const ValidationMessages = {
  VALOR_FATURA_OBRIGATORIO: "Informe o valor total da fatura.",
  VALOR_FATURA_INVALIDO: "Valor da fatura deve ser maior que zero.",
  VALOR_PAGO_MAIOR_FATURA: "Valor pago não pode ser maior que o valor da fatura.",
  TAXA_JUROS_OBRIGATORIA: "Informe a taxa de juros do rotativo.",
  TAXA_JUROS_INVALIDA: "Taxa de juros deve ser maior que zero.",
  TAXA_JUROS_ABUSIVA: "Taxa muito alta! Verifique com seu banco ou considere outras alternativas.",
  DIAS_ATRASO_INVALIDO: "Dias de atraso deve ser um número positivo.",
  NUMERO_MESES_INVALIDO: "Número de meses deve ser entre 1 e 24.",
  LIMITE_LEGAL_EXCEDIDO: "Atenção: Sua dívida atingiu o limite legal de 100% sobre o valor original.",
} as const;

const CONSTANTES_ROTATIVO = {
  IOF_MENSAL: 0.0038,
  IOF_DIARIO: 0.000082,
  DIAS_MES: 30,
  MULTA_PADRAO: 0.02,
  JUROS_MORA_PADRAO: 0.01,
  PERCENTUAL_MINIMO: 0.15,
  LIMITE_LEGAL: 1.0,
  TAXA_ALERTA_ABUSIVA: 0.15,
  TAXA_ROTATIVO_MERCADO: 0.139,
  FATOR_TAXA_PARCELAMENTO: 0.8,
  TAXA_PARCELAMENTO_MAX: 0.099,
  PARCELAS_PADRAO: 12,
} as const;

const ALERTAS_ROTATIVO = {
  TAXA_ALTA: {
    tipo: 'warning' as const,
    titulo: 'Taxa de Juros Elevada',
    icone: '⚠️'
  },
  EDUCATIVO_ROTATIVO: {
    tipo: 'info' as const,
    titulo: 'Por que evitar o Rotativo?',
    icone: '💡'
  }
} as const;

export type {
  RotativoResultsType,
  RotativoInputData,
  RotativoCalculoMes,
  RotativoBreakdown,
  RotativoComparacao,
  RotativoAlerta,
};

export { 
  ValidationMessages, 
  CONSTANTES_ROTATIVO, 
  ALERTAS_ROTATIVO 
};